/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Beta_1Inputs */

const da_terms_beta_1 = /** @type {(inputs: Terms_Beta_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mens AImforA er i beta, kan du få adgang uden betaling. Funktioner kan ændre sig eller blive fjernet, og vi kan afslutte betaen med rimeligt varsel.`)
};

/** @type {(inputs: Terms_Beta_1Inputs) => LocalizedString} */
const en_terms_beta_1 = da_terms_beta_1;

/**

* @param {Terms_Beta_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_beta_1 = /** @type {((inputs?: Terms_Beta_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Beta_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_beta_1(inputs)
	return /** @type {LocalizedString} */ ("Mens AImforA er i beta, kan du få adgang uden betaling. Funktioner kan ændre sig eller blive fjernet, og vi kan afslutte betaen med rimeligt varsel.")
});